import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { textOrDash } from './CustomerReviewCreate.helpers';
import { SOURCE_LABELS } from './CustomerReviewDetail.helpers';
import styles from './CustomerReviewDetail.module.css';

const ReviewOrderCard = ({ review }) => {
  const user = review.user;
  const productVariant = review.product_variant;
  const sale = review.sale;

  const rows = [
    { label: 'Buyer', value: user && user.email },
    { label: 'Product', value: productVariant && productVariant.display_name },
    { label: 'SKU', value: productVariant && productVariant.SKU },
    { label: 'Invoice', value: sale && sale.invoice_number },
    { label: 'Source', value: SOURCE_LABELS[review.source] },
  ];

  return (
    <Card>
      <CardHeader className={styles.cardHeader}>ORDER</CardHeader>
      <CardBody className={styles.cardBody}>
        {rows.map(row => (
          <div className={styles.kvRow} key={row.label}>
            <span className={styles.kvLabel}>{row.label}</span>
            <span className={styles.kvValue}>{textOrDash(row.value)}</span>
          </div>
        ))}
      </CardBody>
    </Card>
  );
};

ReviewOrderCard.propTypes = {
  review: PropTypes.shape({
    source: PropTypes.string,
    user: PropTypes.object,
    product_variant: PropTypes.object,
    sale: PropTypes.object,
  }).isRequired,
};

export default ReviewOrderCard;
